import React from 'react';

import './AuDirectionLink.scss';

/**
 * All direction options
 *
 * @type {Object}
 */
const directions = {
  up: 'au-direction-link__arrow--up',
  right: 'au-direction-link__arrow--right',
  down: 'au-direction-link__arrow--down',
  left: 'au-direction-link__arrow--left',
};

interface IAuDirectionLinkProps {
  text: string;
  className?: string;
  dark?: boolean;
  link?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  direction: 'up' | 'right' | 'down' | 'left';
  style?: React.CSSProperties;
}

/**
 * DEFAULT
 * The direction-links component
 */
const AuDirectionLink: React.FC<IAuDirectionLinkProps> = ({ dark, link, text, direction, onClick, className = '', ...attributeOptions }) => {

  if (link) {
    return (
      <a
        className={`au-direction-link ${className} ${dark ? ' au-direction-link--dark' : ''}`}
        href={link}
        {...attributeOptions}>
        <AuDirectionLinkInner direction={direction} text={text} />
      </a>
    );
  }

  return (
    <button className={`au-direction-link ${className} ${dark ? ' au-direction-link--dark' : ''}`}
      onClick={onClick}
      {...attributeOptions}>
      <AuDirectionLinkInner direction={direction} text={text} />
    </button>
  );
};

interface IAuDirectionLinkInner {
  text: string;
  direction: 'up' | 'right' | 'down' | 'left';
}

/**
 * The inner contents of the direction link. Includes the text and and the arrow.
 */
const AuDirectionLinkInner: React.FC<IAuDirectionLinkInner> = ({ direction, text }) => {
  if (direction === 'left') {
    return (
      <React.Fragment>
        <span className={`au-direction-link__arrow ${directions[direction]} `} aria-hidden='true'></span>{text}
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        {text} <span className={`au-direction-link__arrow ${directions[direction]} `} aria-hidden='true'></span>
      </React.Fragment>
    );
  }
};

export default AuDirectionLink;
